import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PdfEditor from "./components/PdfEditor";
import { ToastContainer } from "./components/Toast";
import toast from "./components/toastApi";
import { useAppSelector } from "../../hooks";
import { selectRole } from "../../states/slices/authReducer";

export default function PdfEditorPage() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const role = useAppSelector(selectRole);

  const searchParams = new URLSearchParams(window.location.search);
  const fileUrl =
    state?.file_path ||
    state?.fileUrl ||
    state?.url ||
    searchParams.get("fileUrl") ||
    null;

  const fileName =
    state?.title ||
    state?.name ||
    state?.fileName ||
    searchParams.get("fileName") ||
    "Document.pdf";

  const handleSave = (pdfBytes: Uint8Array, name: string) => {
    try {
      const blob = new Blob([pdfBytes as any], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = name.endsWith(".pdf") ? name : `${name}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      toast.success("Document saved successfully!");
    } catch (err) {
      toast.error("Failed to save document");
    }
  };

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="w-screen h-screen overflow-hidden">
      <ToastContainer />
      <PdfEditor
        fileUrl={fileUrl}
        fileName={fileName}
        role={role}
        onSave={handleSave}
        onBack={handleBack}
      />
    </div>
  );
}
